import ACLStorage from "lib/aclService";
import { CLASS_RECYCLE_BIN_ACCESS_PERMISSION } from "Constants/permissionConstants";

export const TAB_STATE = {
  ASSIGNMENT: "ASSIGNMENT",
};

export const getIsEnabledRecycleBinForAssignment = () => {
  return ACLStorage.getModuleSettingsValue(CLASS_RECYCLE_BIN_ACCESS_PERMISSION);
};
